import Backbone from 'backbone';
import { titleCase } from 'change-case';

import Base from 'app/models/base';

export default Base.extend({
  parse(attrs) {
    return {
      ...attrs,
      statuses: new Backbone.Collection(attrs.statuses.map(status => {
        return { readable: titleCase(status.status), ...status };
      })),
      categoryReadable: titleCase(attrs.category),
    };
  },
});



// WEBPACK FOOTER //
// ./app/models/tracking_status_report.js